import { LucideIcon } from 'lucide-react';
import { 
  LayoutDashboard, 
  PenTool, 
  FileText, 
  ClipboardList, 
  MessageSquare, 
  TrendingUp, 
  BarChart3, 
  Settings, 
  Users 
} from 'lucide-react';

export enum UserRole {
  SYSTEM_ADMIN = 'system_admin',
  GENERAL_ADMIN = 'general_admin',
  GENERAL_USER = 'general_user'
}

export interface CenterInfo {
  centerId: string;
  centerName: string;
  serverGroup: string;
  serverUrl: string;
}

export interface User {
  id: string;
  userid?: string;  // 사용자 ID (외부 시스템)
  email: string;
  name: string;
  role: UserRole;
  centerId?: string;
  centerInfo?: CenterInfo;
  serverGroup?: string;
  serverUrl?: string;
}

export interface MenuItem {
  path: string;
  label: string;
  icon: LucideIcon | string;
  allowedRoles: UserRole[];
}

export const roleLabels: Record<UserRole, string> = {
  [UserRole.SYSTEM_ADMIN]: '시스템 관리자',
  [UserRole.GENERAL_ADMIN]: '일반 관리자',
  [UserRole.GENERAL_USER]: '일반 사용자'
};

export interface SubMenuItem {
  path: string;
  label: string;
  allowedRoles: UserRole[];
}

export interface MenuItemWithSub extends MenuItem {
  subItems?: SubMenuItem[];
}

export const menuPermissions: MenuItemWithSub[] = [
  { 
    path: '/dashboard', 
    label: '대시보드', 
    icon: LayoutDashboard,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN, UserRole.GENERAL_USER]
  },
  { 
    path: '/survey-builder', 
    label: '설문 작성', 
    icon: PenTool,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
  },
  { 
    path: '/templates', 
    label: '템플릿 라이브러리', 
    icon: FileText,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
  },
  { 
    path: '/survey-list', 
    label: '설문 목록', 
    icon: ClipboardList,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN, UserRole.GENERAL_USER]
  },
  { 
    path: '/survey-responses', 
    label: '응답 확인', 
    icon: MessageSquare,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
  },
  { 
    path: '/analytics', 
    label: '분석', 
    icon: TrendingUp,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
  },
  { 
    path: '/statistics', 
    label: '통계', 
    icon: BarChart3,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN],
    subItems: [
      {
        path: '/statistics/dashboard',
        label: '통계 대시보드',
        allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
      },
      {
        path: '/statistics/data',
        label: '통계 데이터',
        allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
      }
    ]
  },
  {
    path: '/management/survey-types',
    label: '설문 유형',
    icon: Settings,
    allowedRoles: [UserRole.SYSTEM_ADMIN, UserRole.GENERAL_ADMIN]
  },
  {
    path: '/user-management',
    label: '사용자 관리',
    icon: Users,
    allowedRoles: [UserRole.SYSTEM_ADMIN]
  }
];